export const otSaasTabs = {
    maxWidth: 1440,
    init: function () {
        const tabInstance = document.querySelectorAll("[data-ot-tabs]");

        tabInstance.forEach((instance) => {
            const variant = instance.getAttribute("data-ot-tabs-variant");
            const tabList = instance.querySelectorAll("[data-ot-tabs-target]");
            // Get the navlist element
            const instanceNav = instance.querySelector("[data-ot-tabs-navlist]");
            // The tabIndicator element
            const tabIndicator = instance.querySelector("[data-ot-tabs-indicator]");

            // update the tabIndicator
            otSaasTabs.updateIndicator({
                tab: instance.querySelector("[aria-selected='true']"),
                tabIndicator,
                variant,
            });

            // Check initial stat of the tabs
            this.seeMore(instance);

            // Add click event to the next scroll
            instance.querySelector("[data-ot-tabs-more='next']")?.addEventListener("click", () => {
                otSaasTabs.clickNextScroll({ instance });
            });

            // Add click event to the prev scroll
            instance.querySelector("[data-ot-tabs-more='prev']")?.addEventListener("click", () => {
                otSaasTabs.clickPrevScroll({ instance });
            });

            // Check if the navlist scroll position
            instanceNav?.addEventListener("scroll", () => {
                otSaasTabs.checkScroll({ instance });
            });

            // Loop through the tabs
            tabList.forEach((tab) => {
                // Add click event to the tab
                tab.addEventListener("click", (e) => {
                    otSaasTabs.tabClick({ tab: e.target, tabIndicator, variant, instance });
                });

                // Add keydown event to the tab
                tab.addEventListener("keydown", (e) => {
                    const event = e;
                    otSaasTabs.keyboardControls({ tab, event });
                });

                // Add resize event to the window
                window.addEventListener("resize", () => {
                    otSaasTabs.navResize({ instance, tabIndicator, variant });
                });
            });
        });
    },
    centerActive: function ({ tab }) {
        // get the navlist element
        const instanceNav = tab.closest("[data-ot-tabs-navlist]");
        // get the tab position
        const tabPosition = tab.offsetLeft;
        if (tabPosition <= 0)
            return instanceNav.scrollTo({
                left: 0,
                behavior: "smooth",
            });
        // get the instanceNav width
        const instanceNavWidth = instanceNav.getBoundingClientRect().width;
        // get the tab width
        const tabWidth = tab.offsetWidth;
        // scroll the navlist to center the tab
        const centerTabPosition = tabPosition - instanceNavWidth / 2 + tabWidth / 2;

        return instanceNav.scrollTo({
            left: centerTabPosition,
            behavior: "smooth",
        });
    },
    checkScroll({ instance }) {
        const instanceNav = instance.querySelector("[data-ot-tabs-navlist]");
        const scrollPosition = instanceNav.scrollLeft;

        otSaasTabs.checkNextScroll({ instance, scrollPosition, instanceNav });
        otSaasTabs.checkPrevScroll({ instance, scrollPosition });
    },
    checkNextScroll({ instance, scrollPosition, instanceNav }) {
        const screenWidth = window.innerWidth;
        const instanceWidth = instanceNav.scrollWidth;
        const moreNextIndicator = instance.querySelector(
            "[data-ot-tabs-more='next']"
        );
        // Next Scroll
        if (scrollPosition >= instanceWidth - screenWidth) {
            moreNextIndicator.classList.add("hidden");
            moreNextIndicator.tabIndex = -1;
        } else {
            moreNextIndicator.classList.remove("hidden");
            moreNextIndicator.tabIndex = 0;
        }
    },
    checkPrevScroll ({ instance, scrollPosition }) {
        const morePrevIndicator = instance.querySelector(
            "[data-ot-tabs-more='prev']"
        );
        // Prev Scroll
        if (scrollPosition == 0) {
            morePrevIndicator.classList.add("hidden");
            morePrevIndicator.tabIndex = -1;
        } else {
            morePrevIndicator.classList.remove("hidden");
            morePrevIndicator.tabIndex = 0;
        }
    },
    clickNextScroll ({ instance }) {
        const instanceNav = instance.querySelector("[data-ot-tabs-navlist]");
        const screenWidth = window.innerWidth;
        const scrollPosition = instanceNav.scrollLeft;
        const nextScroll = scrollPosition + screenWidth;
        instanceNav.scrollTo({
            left: nextScroll,
            behavior: "smooth",
        });
    },
    clickPrevScroll({ instance }) {
        const instanceNav = instance.querySelector("[data-ot-tabs-navlist]");
        const screenWidth = window.innerWidth;
        const scrollPosition = instanceNav.scrollLeft;
        const prevScroll = scrollPosition - screenWidth;
        instanceNav.scrollTo({
            left: prevScroll,
            behavior: "smooth",
        });
    },
    keyboardControls({ tab, event }) {
        // check if event keycode is not arrow key
        if (event.keyCode < 37 || event.keyCode > 40) return;
        event.preventDefault();
        // if up or right key
        if (event.keyCode === 39 || event.keyCode === 40) {
            otSaasTabs.nextTab({ tab });
        }
        // if down or left key
        if (event.keyCode === 37 || event.keyCode === 38) {
            otSaasTabs.prevTab({ tab });
        }
    },
    hideContent(tab, instance) {
        // Get the id of the clicked tab
        const id = tab.getAttribute("data-ot-tabs-target");
        // Get the active tab
        const activeTab = instance.querySelector("[aria-hidden='false']");
        // Check if the tab is already active
        if (id === activeTab.id) return;
        // Remove the font-bold class from the old tab
        const oldTab = instance.querySelector("[data-ot-tabs-target].font-bold");
        oldTab.classList.remove("font-bold");
        oldTab.setAttribute("aria-selected", "false");
        // Hide the active tab
        activeTab.classList.add("hidden");
        activeTab.setAttribute("aria-hidden", "true");
    },
    navResize({ instance, tabIndicator, variant }) {
        otSaasTabs.updateIndicator({
            tab: instance.querySelector("[aria-selected='true']"),
            tabIndicator,
            variant,
        });
        otSaasTabs.seeMore(instance);
    },
    nextTab({ tab }) {
        // Get the next tab
        const nextTab = tab.nextElementSibling;
        // Confirm if the next tab exists
        if (!nextTab || nextTab.tagName.toLowerCase() !== "button") return;
        tab.tabIndex = -1;
        nextTab.focus();
        nextTab.click();
        nextTab.tabIndex = 0;
    },
    prevTab({ tab }) {
        // Get the previous tab
        const prevTab = tab.previousElementSibling;
        // Confirm if the previous tab exists
        if (!prevTab || prevTab.tagName.toLowerCase() !== "button") return;

        tab.tabIndex = -1;
        prevTab.focus();
        prevTab.click();
        prevTab.tabIndex = 0;
    },
    showContent(tab, instance) {
        // Get the content for the clicked tab
        const tabContent = instance.querySelector(
            `#${tab.getAttribute("data-ot-tabs-target")}`
        );
        // Show the content
        tabContent.setAttribute("aria-hidden", "false");
        tabContent.setAttribute("tabindex", "0");
        tabContent.classList.remove("hidden");
        // Add the font-bold class to the active tab
        tab.classList.add("font-bold");
        tab.setAttribute("aria-selected", "true");
    },
    seeMore(instance) {
        const moreNextIndicator = instance.querySelector(
            "[data-ot-tabs-more='next']"
        );
        const instanceNav = instance.querySelector("[data-ot-tabs-navlist]");
        const instanceWidth = instanceNav.scrollWidth;
        const screenWidth = window.innerWidth;

        if (instanceWidth > screenWidth) {
            moreNextIndicator.classList.remove("hidden");
        } else {
            moreNextIndicator.classList.add("hidden");
        }
    },
    tabClick({ tab, tabIndicator, variant, instance }) {
        otSaasTabs.updateIndicator({
            tab,
            tabIndicator,
            variant,
        });
        otSaasTabs.hideContent(tab, instance);
        otSaasTabs.showContent(tab, instance);
        otSaasTabs.centerActive({ tab });
    },
    updateIndicator({ tab, tabIndicator, variant }) {
        const windowWidth = window.innerWidth;

        if (variant === "vertical" && windowWidth >= otSaasTabs.maxWidth)
            return otSaasTabs.updateVerticalIndicator(tab, tabIndicator);

        return otSaasTabs.updateHorizontalIndicator(tab, tabIndicator);
    },
    updateHorizontalIndicator(tab, tabIndicator) {
        const tabWidth = tab.offsetWidth;
        const tabLeft = tab.offsetLeft;
        tabIndicator.style.height = `8px`;
        tabIndicator.style.top = `auto`;
        tabIndicator.style.bottom = `-1px`; // Overlap 1px with bottom border
        tabIndicator.style.width = `${tabWidth}px`;
        tabIndicator.style.left = `${tabLeft}px`;
        tabIndicator.style.right = `auto`;
    },
    updateVerticalIndicator(tab, tabIndicator) {
        const tabHeight = tab.offsetHeight;
        const tabTop = tab.offsetTop;
        tabIndicator.style.left = "auto";
        tabIndicator.style.right = "0px";
        tabIndicator.style.width = `8px`;
        tabIndicator.style.height = `${tabHeight}px`;
        tabIndicator.style.top = `${tabTop}px`;
        tabIndicator.style.bottom = `auto`;
    },
};
